export default "__VITE_ASSET__B7$muLHa__"